export var useHandlerCDNMultimedia = function () {
    var getCDNMultimedia = function (_a) {
        var path = _a.path, size = _a.size, _b = _a.format, format = _b === void 0 ? true : _b, _c = _a.fill, fill = _c === void 0 ? true : _c, _d = _a.quality, quality = _d === void 0 ? 90 : _d, _e = _a.blur, blur = _e === void 0 ? 0 : _e, settings = _a.settings;
        var imageUrl = "";
        if ((settings === null || settings === void 0 ? void 0 : settings.rutaCdn) && (settings === null || settings === void 0 ? void 0 : settings.cdnActiva) === 1) {
            imageUrl = settings.rutaCdn;
            if (size)
                imageUrl = "".concat(imageUrl, "/fit-in/").concat(size);
            imageUrl = "".concat(imageUrl, "/filters").concat(fill ? ":fill(FFFFFF)" : "");
            imageUrl = "".concat(imageUrl, ":quality(").concat(quality, ")");
            if (format)
                imageUrl = "".concat(imageUrl, ":format(webp)");
            if (blur)
                imageUrl = "".concat(imageUrl, ":blur(").concat(blur, ")");
            imageUrl = "".concat(imageUrl, "/").concat(path);
            return imageUrl;
        }
        else if (settings === null || settings === void 0 ? void 0 : settings.s3BaseUrl) {
            imageUrl = settings.s3BaseUrl;
            return getS3Multimedia({ path: path, settings: settings });
        }
        else {
            throw new Error("No se recibiron configuraciones para obtener la imagen");
        }
    };
    var getS3Multimedia = function (_a) {
        var path = _a.path, settings = _a.settings;
        return "".concat(settings.s3BaseUrl, "/").concat(settings.bucketImagenesS3, "/").concat(path);
    };
    var getVideosFromS3ForArticlesOnly = function (_a) {
        var path = _a.path, settings = _a.settings;
        return "".concat(settings.s3BaseUrl, "/imagenes-loiuruguay/").concat(path);
    };
    return {
        getCDNMultimedia: getCDNMultimedia,
        getS3Multimedia: getS3Multimedia,
        getVideosFromS3ForArticlesOnly: getVideosFromS3ForArticlesOnly
    };
};
/*
//EXAMPLE
    const { getImge } = useImageUrlHandler();

    getImge({
        imagePath: "_img_productos/notebook-lenovo-82c4s0f8us-foto1-1718368606.jpg",
        size: "400x400",
    });
*/
